module.exports = __webpack_public_path__ + "img/serviceState4.2e964f93.svg";